import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isLoyaltyProgram", "promotion"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Box } from "../../../index.js";
import { PromotionBanner, promotionBannerDefaultProps, promotionBannerPropTypes } from "./PromotionBanner";
export var BasketTargetProductBanner = function BasketTargetProductBanner(_ref) {
  var isLoyaltyProgram = _ref.isLoyaltyProgram,
    promotion = _ref.promotion,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, {
    "data-testid": "organisms-DetailPromotionBanner-Box"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      '@media (max-width: 767px)': {
        display: 'flex',
        justifyContent: 'center'
      }
    },
    "data-testid": "organisms-DetailPromotionBanner-Box-1"
  }, /*#__PURE__*/React.createElement(Box, _extends({
    width: 0,
    height: 0,
    borderLeft: "12px solid transparent",
    borderRight: "12px solid transparent",
    borderBottom: "12px solid var(ui-06-lighter)",
    m: "0 0 var(--chakra-space-sm)",
    "border-radius": "var(--chakra-space-3xs)",
    sx: {
      '@media (max-width: 767px)': {
        ml: 'calc(var(--chakra-space-md) * 3.75)'
      }
    }
  }, isLoyaltyProgram ? {
    borderBottom: '12px solid var(primary-00-yellow)'
  } : {}, {
    "data-testid": "organisms-DetailPromotionBanner-Box-2"
  }))), /*#__PURE__*/React.createElement(PromotionBanner, _extends({
    promotion: promotion
  }, props, {
    "data-testid": "organisms-DetailPromotionBanner-PromotionBanner"
  })));
};
BasketTargetProductBanner.defaultProps = _objectSpread(_objectSpread({}, promotionBannerDefaultProps), {}, {
  isLoyaltyProgram: false
});
export default BasketTargetProductBanner;